// extracted by mini-css-extract-plugin
module.exports = {"display":"Application_display__3hke0","btn_div":"Application_btn_div__3OU1M","display__time":"Application_display__time__f5R-3"};